import React from 'react';
import '../../css/error-pages.css';
import pbgLogoBlue from '../../img/keytravel-logo-blue.png';

export default () => (
  <div className="error-wrapper error-422">
    <div className="header">
      <a href="/" title="Key Travel">
        <img src={pbgLogoBlue} alt="Key Travel" />
      </a>
    </div>
    <div className="floater" />
    <div className="dialog">
      <h1>422</h1>
      <p className="description">
        Uh oh, looks like you're not allowed to access this page.<br />
        Neither am I. Maybe my people can help. Email them at:<br />
        <a href="mailto:info@keytravel.com" target="_blank" rel="noopener noreferrer">
          info@keytravel.com
        </a>
      </p>
    </div>
  </div>
);




// WEBPACK FOOTER //
// ./src/desktop/components/error-pages/unprocessable.js